// extracted by mini-css-extract-plugin
export var link = "Menu-module--link--3457a";
export var menu = "Menu-module--menu--db3c2";
export var menuItem = "Menu-module--menuItem--8cead";
export var menuWrapper = "Menu-module--menuWrapper--03194";